module.exports = __webpack_public_path__ + "9e2b0ff1dd2b7660671efe9d4c3b31b8.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/field-horsetail.jpg
 ** module id = 197
 ** module chunks = 0
 **/